export const URL_SELF =
  process.env.NEXT_PUBLIC_VERCEL_ENV === "preview" &&
  process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF !== "dev"
    ? `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`
    : (process.env.NEXT_PUBLIC_SELF_URL ?? "");
